const messages = {
    title: "Generer rapport",
    personal_data: {
        title: "Personopplysninger",
        email: "E-post",
        salutation: "Tiltaleform",
        first_name: "Fornavn",
        last_name: "Etternavn",
        job_position: "Stilling i selskapet"
    },
    shipping_address: {
        title: "Leveringsadresse",
        company: "Selskapsnavn",
        street: "Gate og nummer",
        postal_code: "Postnummer",
        mobile_phone: "Mobiltelefon",
        iban_number: "IBAN",
        vat: "MVA-nummer",
        additional_address: "Tilleggsadresse",
        city: "Sted"
    },
    operating_data: {
        title: "Driftsdata",
        customer_number: "Kundenummer",
        group: "Gruppe",
        customer_group: "Gruppe",
        first_registration: "Første registrering",
        last_login: "Sist innlogget",
        tires_per_year: "Dekk per år",
        over_18_inch: "Over 18 tommer",
        premium: "Premium",
        middle: "Middels",
        summer: "Sommer",
        winter: "Vinter",
        all_season: "All sesong",
    },
    calculated_data: {
        title: "Beregnede data",
        tireAmount: "Dekkantall",
        points: "Poeng",
        bonus: "Bonus"
    },
    sales_structure: {
        title: "Salgsstruktur",
        sales_representative: {
            title: "Salgsrepresentant",
        },
        distributor: {
            title: "Distributør",
        },
    },
    meta: {
        title: "Metadata",
        brand: {
            title: "Merke",
            none: ''
        },
        tireType: {
            title: "Dekktype",
            none: ''
        },
        year: {
            title: "År",
            "2020": "2020",
            "2021": "2021",
            "2022": "2022",
            "2023": "2023",
            "2024": "2024",
            "2025": "2025"
        },
        calendarMonth: {
            title: "Kalendermåned",
            january: "Januar",
            february: "Februar",
            march: "Mars",
            april: "April",
            may: "Mai",
            june: "Juni",
            july: "Juli",
            august: "August",
            september: "September",
            october: "Oktober",
            november: "November",
            december: "Desember"
        },

    },
    selectAll: "Velg alle",
    reset: "Tilbakestill filter",
    generate: "Generer rapport",
    loadingInfo: 'Genererer rapport, vennligst vent...',
};

export default {
    messages,
};
